import { atom, action } from "@reatom/framework";

export const isCardViewAtom = atom<boolean>(false, "isCardViewAtom");
export const updateCardView = action((ctx, view: boolean) => {
  isCardViewAtom(ctx, view);
}, "updateCardView");
